import { apiClient } from './config'

export const APPLICATION_STATUS = {
  SENT: 'SENT',
  IN_DISCUSSION: 'IN_DISCUSSION',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CLOSED: 'CLOSED',
}

export const APPLICATION_STATUS_LABELS = {
  SENT: { label: 'Envoyée', color: 'bg-blue-100 text-blue-800' },
  IN_DISCUSSION: { label: 'En discussion', color: 'bg-amber-100 text-amber-800' },
  ACCEPTED: { label: 'Acceptée', color: 'bg-green-100 text-green-800' },
  REJECTED: { label: 'Refusée', color: 'bg-red-100 text-red-800' },
  CLOSED: { label: 'Clôturée', color: 'bg-slate-100 text-slate-800' },
}

export const POST_TYPE_LABELS = {
  JOB: 'Offre d\'emploi',
  REQUEST: 'Demande',
  SERVICE: 'Service',
}

export const getPostDetailPath = (post) => {
  if (!post?.id) return null
  if (post.type === 'JOB') return `/emplois/${post.id}`
  if (post.type === 'REQUEST') return `/demandes/${post.id}`
  return null
}

export const getApplicationChatPath = (application) => {
  if (!application?.chatId) return null
  const postId = application.postId ?? application.post?.id
  if (postId) {
    return `/tableau-de-bord/messagerie/post/${postId}/chat/${application.chatId}`
  }
  return `/tableau-de-bord/messagerie/chat/${application.chatId}`
}

export const applicationsService = {
  async apply(postId, message) {
    return apiClient.post('/applications', { postId, message })
  },

  async getApplicationById(id) {
    return apiClient.get(`/applications/${id}`)
  },

  async updateApplicationStatus(id, status) {
    return apiClient.patch(`/applications/${id}`, { status })
  },

  async acceptApplication(id) {
    return this.updateApplicationStatus(id, APPLICATION_STATUS.ACCEPTED)
  },

  async rejectApplication(id) {
    return this.updateApplicationStatus(id, APPLICATION_STATUS.REJECTED)
  },

  async getSentApplications(params = {}) {
    const { page = 1, limit = 20 } = params
    return apiClient.get(`/applications/sent?page=${page}&limit=${limit}`)
  },

  async getReceivedApplications(params = {}) {
    const { page = 1, limit = 20 } = params
    return apiClient.get(`/applications/received?page=${page}&limit=${limit}`)
  },
}
